<div class="container">
    <form [formGroup]="myForm">
        <mat-card class="no_box_shadow">
            <mat-card-content>
                <div class="example-button-row">
                    <span class="__filter_icon">
                        <mat-icon>filter_alt</mat-icon>
                    </span>
                    <button mat-stroked-button>Apply pre-defined filters</button>
                    <button mat-stroked-button>Apply pre-defined filters</button>
                    <button mat-stroked-button color="primary">Filter 3</button>
                    <button mat-stroked-button>Filter 4</button>
                    <a [ngClass]="{hide:!addPermission}" class="__add_client" (click)="createClient()">
                        <mat-icon class="__icon">add_circle</mat-icon>
                        Create Client
                    </a>
                </div>
                <mat-divider></mat-divider>
                <table [hidden]="!viewPermission" mat-table matSort [dataSource]="clients">
                    <ng-container matColumnDef="clientCode">
                        <th class="header" mat-header-cell *matHeaderCellDef>
                            <div class="sorting_header">
                                <span mat-sort-header>Client Code</span>
                                <mat-form-field class="filter search_box">
                                    <!-- <mat-label>Search by Client Code</mat-label> -->
                                    <input type="search" placeholder="Search by Client Code" matInput
                                        formControlName="codeFilter" autocomplete="off">
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{element.code}}</td>
                    </ng-container>
                    <ng-container matColumnDef="clientName">
                        <th class="header" mat-header-cell *matHeaderCellDef>
                            <div class="sorting_header">
                                <span mat-sort-header>Client Name</span>
                                <mat-form-field class="filter search_box">
                                    <!-- <mat-label>Search by Client Name</mat-label> -->
                                    <input placeholder="Search by Client Name" matInput formControlName="nameFilter"
                                    autocomplete="off" >
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{element.name}}</td>
                    </ng-container>
                    <ng-container matColumnDef="country">
                        <th mat-header-cell *matHeaderCellDef><span mat-sort-header>Country</span></th>
                        <td mat-cell *matCellDef="let element"> {{element?.address?.countryName}} </td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef><span class="mat-sort-header-content">Status</span></th>
                        <td mat-cell *matCellDef="let element">{{element.status}}</td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef><span class="mat-sort-header-content">Action</span></th>
                        <td class="__action_row" mat-cell *matCellDef="let element">
                            <span [ngClass]="{hide:!editPermission}" class="__action_edit_icon" (click)="editClient(element.id)">
                                <mat-icon>create</mat-icon>
                            </span>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="clientColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: clientColumns"></tr>
                </table>

            </mat-card-content>
        </mat-card>
        <mat-paginator [ngClass]="{hide:!viewPermission}" [pageSizeOptions]="[10, 20, 25]" showFirstLastButtons></mat-paginator>
    </form>
</div>